// Dependencies
import { useEffect, useState } from "react";

export default function useMount() {
	const [ready, set] = useState(false);
	useEffect(() => {
		set(true)
	}, [])
	return ready
}